export const guardedTrim = (text: string | undefined = '') => text.trim();
